import { z } from 'zod';
import { SanityDocumentSchema } from '../sanity';
import { ComponentType } from '$lib/sanity/types';
import { GridLayoutSchema } from '../shared';
import { NewsTagSchema } from '../entities/NewsTag';

export const NewsSectionSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.NewsSection),
  name: z.string(),
  tags: z.array(NewsTagSchema).nullish().default([]),
  layout: GridLayoutSchema.nullish()
});

export const NewsSectionArraySchema = z.array(NewsSectionSchema);

export type NewsSection = z.infer<typeof NewsSectionSchema>;
export type NewsSectionArray = z.infer<typeof NewsSectionArraySchema>;
